<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px">
                <col>
            </colgroup>
            <tr>
                <td class="c_t_title">검색창 노출 문구</td>
                <td>
                    <div class="d_block">
                        <el-input v-model="sentence" @input="parentChange('sentence', sentence)" placeholder="노출 문구를 입력해주세요." ></el-input>
                        <div class="input_error">{{ validation.firstError('sentence') }}</div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import ExampleValidator from "@/mixins/validators/ExampleValidator";
import EventBus from "@/mixins/event-bus";
import util from '@/mixins/util';

export default {
    name: "ExampleWriteDefaultLayout",
    mixins: [ExampleValidator],
    components: {},
    inject: ['exampleWriteSetData'],
    provide() {
        return {}
    },
    props: {
        exampleData: {},
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
        if (this.hasData()) {
            this.setInitData();
        }
        EventBus.$on('ExampleWriteDefaultLayoutValidator', this.checkValidator);
    },
    beforeDestroy() {
        EventBus.$off('ExampleWriteDefaultLayoutValidator')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setInitData() {
            this.sentence = this.exampleData.ek_sentence;
            this.parentChange('sentence', this.sentence);
        },
        hasData() {
            return !util.isEmpty(this.exampleData);
        },
        checkValidator(dataArr) {
            this.$validate(dataArr)
        },
        parentChange(key, value) {
            this.exampleWriteSetData(key, value);
        },
    },
    watch: {}
}
</script>

<style scoped>

</style>